import { usePeer } from '@/providers/PeerjsProvider'
import ConnectionIndicator from '@/components/ui/meeting/ConnectedIndicator'

function PeerConnectionIndicator() {
  const { connectedPeers } = usePeer()
  return <ConnectionIndicator connectedPeers={connectedPeers} />
}

export default PeerConnectionIndicator
